import { render, staticRenderFns } from "./MediaButton.vue?vue&type=template&id=369b1f72&scoped=true"
import script from "./MediaButton.vue?vue&type=script&lang=js"
export * from "./MediaButton.vue?vue&type=script&lang=js"
import style0 from "./MediaButton.vue?vue&type=style&index=0&id=369b1f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b1f72",
  null
  
)

export default component.exports